import { applicationActions } from "../reducer";

export const resetNotice = () => applicationActions.deleteNotice();
